import { logError } from '@core/logging';
export var PostMessageSentinelEnum;
(function (PostMessageSentinelEnum) {
    PostMessageSentinelEnum["INTERNAL"] = "fwn-internal";
    PostMessageSentinelEnum["EXTERNAL"] = "fwn";
})(PostMessageSentinelEnum || (PostMessageSentinelEnum = {}));
export const postMessageWrapper = (message) => {
    const windows = window.parent !== window ? [window.parent, window] : [window];
    windows.forEach((w) => {
        var _a, _b, _c;
        try {
            w === null || w === void 0 ? void 0 : w.postMessage(Object.assign({ sentinel: PostMessageSentinelEnum.EXTERNAL }, message), ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin) && ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.origin) !== 'null'
                ? (_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.origin
                : '*');
        }
        catch (err) {
            logError(err);
        }
    });
};
